import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

export const readOrganizationTwilioRegistrations = async <
  T extends Record<string, unknown>,
>({
  query,
  domain,
  headers,
  organizationId,
}: FetchRequestArgs & { organizationId: string }): Promise<
  ReturnType<typeof fetchRequest>
> =>
  fetchRequest<T>({
    domain,
    endpoint: `/v2/organization/${organizationId}/messaging/settings/twilio_registrations`,
    headers,
    method: HTTPMethod.GET,
    query,
  });
